import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconAngleRight: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 32">
      <path d="M1.6 3.733L5.333 0l16 16-16 16L1.6 28.267 13.867 16z" />
    </svg>
  </IconStyled>
);

IconAngleRight.defaultProps = iconDefaultProps;
IconAngleRight.displayName = 'IconAngleRight';

export default IconAngleRight;
